/* Regler mit zwei Griffen fuer die Von-bis-Felder der Masse (Kunde 04.11.: "von bis mit regler").
   Der Regler laeuft ueber die tatsaechlich vorhandenen Werte (sortiert, ohne Doppelte), nicht linear:
   so laesst sich bei 6 bis 800 mm auch im Bereich 10 bis 20 fein einstellen.
   Griff ganz links bzw. ganz rechts = keine Grenze (Feld bleibt leer). Loslassen filtert sofort.
   Shopify-Filter (mb-filter-gruppe): Werte aus den versteckten Haekchen (data-zahl).
   Eigener Filter grosser Kategorien (mb-filter-gross.js): ruft mbRegler.init(box, werte) selbst auf. */
(function () {
  var zahl = function (s) { var n = parseFloat(String(s).replace(',', '.')); return isNaN(n) ? NaN : n; };
  function init(box, werte) {
    if (!box || werte.length < 2) return;
    var r = box.previousElementSibling && box.previousElementSibling.classList.contains('mbr') ? box.previousElementSibling : null;
    if (!r) {
      r = document.createElement('div');
      r.className = 'mbr';
      r.innerHTML = '<div class="mbr-spur"><div class="mbr-fuell"></div></div><input type="range" class="mbr-a" aria-label="von"><input type="range" class="mbr-b" aria-label="bis">';
      box.parentNode.insertBefore(r, box);
    }
    var a = r.querySelector('.mbr-a'), b = r.querySelector('.mbr-b'), fuell = r.querySelector('.mbr-fuell');
    var von = box.querySelector('.mbf-von'), bis = box.querySelector('.mbf-bis');
    var n = werte.length - 1;
    [a, b].forEach(function (x) { x.min = 0; x.max = n; x.step = 1; });
    var naechster = function (v) { var best = 0; for (var i = 1; i <= n; i++) if (Math.abs(werte[i] - v) < Math.abs(werte[best] - v)) best = i; return best; };
    var fuellen = function () { fuell.style.left = (a.value / n * 100) + '%'; fuell.style.right = (100 - b.value / n * 100) + '%'; };
    var ausFeldern = function () {
      var va = zahl(von.value), vb = zahl(bis.value);
      a.value = isNaN(va) ? 0 : naechster(va);
      b.value = isNaN(vb) ? n : naechster(vb);
      fuellen();
    };
    r.werte = werte;
    ausFeldern();
    if (r.bereit) return;
    r.bereit = true;
    a.addEventListener('input', function () {
      if (+a.value > +b.value) a.value = b.value;
      von.value = +a.value === 0 ? '' : r.werte[a.value];
      fuellen();
    });
    b.addEventListener('input', function () {
      if (+b.value < +a.value) b.value = a.value;
      bis.value = +b.value === +b.max ? '' : r.werte[b.value];
      fuellen();
    });
    var senden = function () { var f = box.closest('form'); if (f.requestSubmit) f.requestSubmit(); else f.submit(); };
    a.addEventListener('change', senden);
    b.addEventListener('change', senden);
    von.addEventListener('input', ausFeldern);
    bis.addEventListener('input', ausFeldern);
  }
  window.mbRegler = { init: init };
  document.querySelectorAll('[data-bereich]').forEach(function (box) {
    var w = {};
    box.parentNode.querySelectorAll('input[data-zahl]').forEach(function (c) { var z = zahl(c.dataset.zahl); if (!isNaN(z)) w[z] = 1; });
    init(box, Object.keys(w).map(Number).sort(function (x, y) { return x - y; }));
  });
})();
